module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_f_melanistic.33bb54d5.png";